module.exports = __webpack_public_path__ + "img/fct.5397ce0a.jpg";